import "./TripStyles.css";
import TripData from "./TripData";
import Trip1 from "../assets/5.jpg";
import Trip2 from "../assets/8.jpg";
import Trip3 from "../assets/6.jpg";

function Trip() {
  return (
    <div className="trip">
    <h1>Recent Trips</h1>
    <p>You can discover unique destinations by using Google Maps.</p>
     <div className="tripcard"> 
     <TripData
     image={Trip1}
     heading="Trip in Indoneia"
     text="Indonesia is a captivating destination that beckons travelers with its diverse landscapes, vibrant culture, and rich heritage. From the pristine beaches of Bali to the lush rainforests of Borneo, this archipelago nation offers a myriad of experiences waiting to be discovered.

     Embark on a journey through Indonesia and immerse yourself in the enchanting beauty of its tropical paradise. Explore ancient temples such as Borobudur and Prambanan, marveling at their intricate architecture and spiritual significance. Dive into the crystal-clear waters of Raja Ampat, home to some of the world's most biodiverse marine life, or trek through the jungles of Sumatra in search of elusive orangutans."
     />
     <TripData
     image={Trip2}
     heading="Trip in Malaysia"
     text="Malaysia beckons travelers with its unique blend of vibrant cities, stunning natural landscapes, and rich cultural diversity. From the bustling streets of Kuala Lumpur to the tranquil beaches of Langkawi, this Southeast Asian gem offers a wealth of experiences waiting to be discovered.Venture into the lush rainforests of Taman Negara, one of the oldest tropical rainforests in the world, and encounter exotic wildlife such as orangutans, proboscis monkeys, and pygmy elephants. Explore the breathtaking landscapes of the Cameron Highlands, where rolling tea plantations and cool mountain air create an idyllic escape from the heat of the lowlands."
     />
     <TripData
     image={Trip3}
     heading="Trip in France"
     text="France is a timeless destination that captivates travelers with its exquisite art, rich history, culinary delights, and breathtaking landscapes. From the romantic streets of Paris to the sun-drenched vineyards of Provence, this European gem offers an unparalleled journey through culture, cuisine, and charm.France's culinary scene is a highlight of any trip, with its world-renowned cuisine, fine wines, and gourmet delights"
     
     />
     </div>
    </div>
  );
}

export default Trip;
